/** Shared route paths for the ND1 marketing shell (canonical URLs after cutover). */
export const ND1_HOME = "/";
export const ND1_SIGNIN = "/signin";
export const ND1_SIGNUP = "/signup";
export const ND1_VERIFY_EMAIL = "/verify-email";
export const ND1_VERIFY_MOBILE = "/verify-mobile";
export const ND1_FORGOT_PASSWORD = "/forgot-password";
export const ND1_RESET_PASSWORD = "/reset-password";
export const ND1_CHANGE_EMAIL = "/change-email";
export const ND1_CHANGE_MOBILE = "/change-mobile";
export const ND1_TERMS = "/terms";
export const ND1_PRIVACY = "/privacy";
export const ND1_COOKIES = "/cookies";
export const ND1_HIW_APPLYING = "/how-it-works/applying";
export const ND1_HIW_HIRING = "/how-it-works/hiring";
export const ND1_PRICING = "/pricing";

/** Contextual sign-up URL based on the current marketing page. */
export function getNd1SignupHref(pathname) {
  if (pathname.startsWith("/hiring-managers") || pathname.startsWith(ND1_HIW_HIRING) || pathname.startsWith(ND1_PRICING)) {
    return `${ND1_SIGNUP}?type=hiring-manager`;
  }
  if (pathname.startsWith("/job-seekers") || pathname.startsWith(ND1_HIW_APPLYING)) {
    return `${ND1_SIGNUP}?type=applicant`;
  }
  return ND1_SIGNUP;
}
